import { Spinner, SpinnerSize } from '@fluentui/react';
import { Button, Label, Link, useFluent } from '@fluentui/react-components';
import { CheckmarkCircle20Filled, ErrorCircle20Filled, } from '@fluentui/react-icons';
import { isFocusableHtmlElement } from '@office-start/dom-utility';
import { ToastTypes } from '@office-start/toast-types';
import React, { useCallback, useRef } from 'react';
import { errorIconPrimaryFillColor, successIconPrimaryFillColor, } from './constants';
import { useToastElementControlStyles } from './ToastElementControl.styles';
export var ToastElementControl = function (_a) {
    var animate = _a.animate, ariaLabel = _a.ariaLabel, button = _a.button, buttonAriaLabel = _a.buttonAriaLabel, label = _a.label, link = _a.link, type = _a.type;
    var styles = useToastElementControlStyles();
    var dir = useFluent().dir;
    // Get a reference to last active element
    var initialActiveElementRef = useRef(isFocusableHtmlElement(document.activeElement)
        ? document.activeElement
        : null);
    // Focus the button if there is an action
    var onButtonRef = useCallback(function (ref) {
        if (ref && initialActiveElementRef.current) {
            ref.focus();
            initialActiveElementRef.current = null;
        }
    }, []);
    // No empty label
    if (!label) {
        return null;
    }
    // Get Icon Element
    var iconElement;
    if (type == ToastTypes.InProgress) {
        var spinnerIconProps = {
            // These colors are not from Fluent palette by design
            circle: {
                border: '1.5px solid rgba(248, 210, 42, 0.1)',
                borderTopColor: '#F8D22A',
            },
        };
        if (typeof animate === 'boolean' && !animate) {
            spinnerIconProps.circle['animation'] = 'none';
        }
        iconElement = (React.createElement(Spinner, { size: SpinnerSize.small, styles: spinnerIconProps, className: styles.icon }));
    }
    else if (type == ToastTypes.Success) {
        iconElement = (React.createElement("span", { className: styles.icon },
            React.createElement(CheckmarkCircle20Filled, { primaryFill: successIconPrimaryFillColor })));
    }
    else {
        iconElement = (React.createElement("span", { className: styles.icon },
            React.createElement(ErrorCircle20Filled, { primaryFill: errorIconPrimaryFillColor })));
    }
    // Get button Element
    var buttonElement;
    if (button) {
        buttonElement = (React.createElement(Button, { "aria-label": buttonAriaLabel, onClick: button.onClick, appearance: "transparent", className: styles.toastButton, ref: onButtonRef, size: "small" }, button.label));
    }
    return (React.createElement("div", { dir: dir, className: styles.toastElementDiv },
        iconElement,
        React.createElement("div", { className: styles.labelDiv },
            React.createElement(Label, { "aria-label": ariaLabel, className: styles.toastLabel }, label),
            link ? (React.createElement(Link, { className: styles.toastLink, href: link.url, "aria-label": link.ariaLabel, target: "_blank" }, link.label)) : null),
        buttonElement));
};
//# sourceMappingURL=ToastElementControl.js.map